import reduceLodash from 'lodash.reduce';

/**
 * This is a port of reduce function from lodash.
 * Lodash is bloated and not necessary in many cases.
 * There is no native equivalent to this since it works for both objects and arrays,
 * so a port of it will maintain the same behavior
 * and have a smaller footprint.
 */
export const reduce = reduceLodash;
